// l - left, r - right, t - top, b - bottom
const factors = {
  lt: { x: 1, y: 1, w: -1, h: -1 },
  lb: { x: 1, y: 0, w: -1, h: 1 },
  rt: { x: 0, y: 1, w: 1, h: -1 },
  rb: { x: 0, y: 0, w: 1, h: 1 },
}

const minHeights = {
  linear: 30,
}

const minWidths = {
  linear: 160,
}

// из определения стиля 'translate(1px, 2px)' извлечь значения x и y
const parseTranslate = (translate: string) => {
  const xStart = translate.indexOf('(') + 1
  const xEnd = translate.indexOf('px')

  const yStart = translate.indexOf(', ') + 2
  const yEnd = translate.indexOf('px)')

  const x = +translate.slice(xStart, xEnd) || 0
  const y = +translate.slice(yStart, yEnd) || 0

  return [x, y]
}

const cardPositionControlsUtils = { factors, minWidths, minHeights, parseTranslate }
export default cardPositionControlsUtils
